import type {ComputationResult} from './../computation-result';
import type {Computation} from './../computation';
import type {UnitRootTest, _UnitRootTest} from './unit-root-test';

/**
 * Generated from com.dataiku.dip.eda.compute.computations.timeseries.UnitRootTestZA
 */
export interface UnitRootTestZA extends _UnitRootTest {
    nLags?: number | null;
    regressionMode: UnitRootTestZA.RegressionMode;

    // PolyJson type
    type: 'unit_root_za';
}

export namespace UnitRootTestZA {
    export const type = 'unit_root_za';
}

/** @deprecated Use Computation.isUnitRootTestZA() */ export function isUnitRootTestZA(toTest: Computation): toTest is UnitRootTestZA { return UnitRootTestZA.type === toTest['type']; }

export namespace UnitRootTestZA {
    /**
     * Generated from com.dataiku.dip.eda.compute.computations.timeseries.UnitRootTestZA$UnitRootTestZAResult
     */
    export interface UnitRootTestZAResult extends UnitRootTest._UnitRootTestResult {
        // PolyJson type
        type: 'unit_root_za';
    }

    export namespace UnitRootTestZAResult {
        export const type = 'unit_root_za';
    }

    /** @deprecated Use ComputationResult.isUnitRootTestZAResult() */ export function isUnitRootTestZAResult(toTest: ComputationResult): toTest is UnitRootTestZAResult { return UnitRootTestZAResult.type === toTest['type']; }

    /**
     * Generated from com.dataiku.dip.eda.compute.computations.timeseries.UnitRootTestZA$RegressionMode
     */
    export enum RegressionMode {
        CONSTANT_ONLY = 'CONSTANT_ONLY',
        TREND_ONLY = 'TREND_ONLY',
        CONSTANT_WITH_TREND = 'CONSTANT_WITH_TREND'
    }
}